import { ApiBase } from "@/api/ApiBase";

export interface PacoteLicenca {
  id: number;
  valor: number;
  prazo: string;
}

export interface PlanoLicenca {
  plano: "Facturacao" | "Comercial";
  pacotes: PacoteLicenca[];
}

export interface SubscricaoHistorico {
  custo: number;
  data_criacao: string;
  data_final: string;
  data_inicial: string;
  descricao: string;
  estado: "Activo" | "Expirado" | "Anulado";
  pacote_id: number;
}

export interface PageSubscricoes {
  content: SubscricaoHistorico[];
}

/** Formato devolvido pelo LicencaController de uma instalação OFFLINE: vem
 * da licença em memória, não da base de dados — sem paginação real, sem
 * custo/descrição/pacote. */
export interface SubscricaoOffline {
  dataInicial: string;
  dataFinal: string;
  estado: "Activo" | "Expirado" | "Anulado";
}

export interface PagamentoExpressResponse {
  msg: string;
  tipo: "Sucesso" | "Falha";
}

export interface ExperimentarGratisResponse {
  msg: string;
  tipo: "sucesso" | "erro";
}

const TIMEOUT_PAGAMENTO_EXPRESS_MS = 65000;

export class LicencaApi extends ApiBase {
  listaPlanosEPacotes(): Promise<PlanoLicenca[]> {
    return this.http.put<PlanoLicenca[]>("/api/licenca/lista-planos-e-pacotes");
  }

  listaSubscricoes(pagina: number): Promise<PageSubscricoes> {
    return this.http.put<PageSubscricoes>(
      `/api/licenca/lista-subscricoes-comerciante/${pagina}`,
    );
  }

  listaSubscricoesOffline(): Promise<SubscricaoOffline[]> {
    return this.http.put<SubscricaoOffline[]>(
      "/api/licenca/lista-subscricoes-comerciante",
    );
  }

  pagarPorMulticaixaExpress(
    pacoteId: number,
    telefone: string,
  ): Promise<PagamentoExpressResponse> {
    return this.http.post<PagamentoExpressResponse>(
      "/api/licenca/assinar-por-multicaixa-express",
      { PACOTE: String(pacoteId), TELEFONE: telefone },
      TIMEOUT_PAGAMENTO_EXPRESS_MS,
    );
  }

  /** Telefone do último pagamento Multicaixa Express confirmado com êxito
   * (consumido uma única vez pelo servidor — devolve null se nada de novo
   * desde a última leitura). Usado para recuperar de falsos "erro" quando o
   * pedido original falha no cliente (ex.: app em segundo plano no
   * telemóvel) mas o pagamento já tinha sido confirmado no servidor. */
  getPhoneLastPay(): Promise<string | null> {
    return this.http.put<string | null>("/api/licenca/get-phone-last-pay");
  }

  experimentar7DiasGratis(plano: string): Promise<ExperimentarGratisResponse> {
    return this.http.post<ExperimentarGratisResponse>(
      "/api/licenca/experimentar-7dias-gratis",
      { PAC: plano },
    );
  }
}
